import type { Timeslot } from '../types';

export function isTimeslotPast(ts: Timeslot, now = Date.now()): boolean {
  return new Date(ts.endTs).getTime() <= now;
}

export function isTimeslotCurrent(ts: Timeslot, now = Date.now()): boolean {
  const t = now;
  return new Date(ts.startTs).getTime() <= t && t < new Date(ts.endTs).getTime();
}

export function getTimeslotProgress(ts: Timeslot, now = Date.now()): number {
  const start = new Date(ts.startTs).getTime();
  const end = new Date(ts.endTs).getTime();
  if (end <= start) return 0;
  return Math.min(1, Math.max(0, (now - start) / (end - start)));
}

export function getSessionEndTs(
  timeslots: Timeslot[],
  startIndex: number,
  spanSlots: number
): string | null {
  const endIndex = startIndex + spanSlots - 1;
  const endSlot = timeslots.find((t) => t.indexInDay === endIndex);
  if (endSlot) return endSlot.endTs;
  const startSlot = timeslots.find((t) => t.indexInDay === startIndex);
  return startSlot?.endTs ?? null;
}

export function isSessionPast(
  timeslots: Timeslot[],
  startIndex: number,
  spanSlots: number,
  now = Date.now()
): boolean {
  const endTs = getSessionEndTs(timeslots, startIndex, spanSlots);
  if (!endTs) return false;
  return new Date(endTs).getTime() <= now;
}

export function findCurrentTimeslot(timeslots: Timeslot[], now = Date.now()): Timeslot | null {
  return timeslots.find((ts) => isTimeslotCurrent(ts, now)) ?? null;
}
